import React, { Fragment } from "react";
import { Header, SideNav, Footer, PlusButton, ErrorBoundary, TailgateReminder } from "components";

const DesktopLayout = (props) => {
  const { consultation } = props;

  return (
    <div className={"page-wrap" + (consultation === true ? " consultation" : "")}>
      <SideNav consultation={consultation === true} />

      <div className="page-content">
        <ErrorBoundary>
          {consultation === true && <TailgateReminder />}
          {props.children}
        </ErrorBoundary>

        {consultation !== true && <Footer />}
      </div>

      {consultation === true && <PlusButton />}
    </div>
  );
};

export default DesktopLayout;
